export const NO_SYNCED_TESTS_TITLE = 'No synced tests';
export const NO_SYNCED_TESTS_MSG =
	'Sync tests on your desktop app with the Evinced Platform to allow peer collaboration and comparison over time. \nContact us for more details.';
